import CollectionIcon from "../components/icons/CollectionIcon";
import FolderIcon from "../components/icons/FolderIcon";
import { UserGroupIcon } from "../components/icons/UserGroupIcon";
import { UserRole } from "../lib/models/enums";
import { SidebarLink } from "../lib/types/SidebarLink";
import { isElevatedUser } from "../lib/UserPermissions";

export class NavigationLinkService {
  public static readonly sidebarLinks: SidebarLink[] = [
    {
      label: "My Quotes",
      icon: FolderIcon,
      path: "/quotes/my-quotes",
    },
  ];

  public static getSideBarLinksByRole(
    role: UserRole,
    numberOfBrokers: number
  ): SidebarLink[] {
    const links = [...this.sidebarLinks];

    if (isElevatedUser(role)) {
      links.push({
        label: "All Quotes",
        icon: CollectionIcon,
        path: "/quotes",
      });
    }

    if (numberOfBrokers > 0) {
      links.push({
        label: "Brokers",
        icon: UserGroupIcon,
        path: "/quotes/broker-quotes",
        badge: numberOfBrokers,
      });
    }

    return links;
  }
}
